"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputButtonStyle = void 0;
const design_system_1 = require("@zapier/design-system");
exports.inputButtonStyle = {
    background: 'none',
    border: 'none',
    display: 'flex',
    margin: 0,
    padding: 6,
    '&:hover, &:focus, &:active': {
        background: 'none',
        color: design_system_1.Colors.blue500,
        outline: 'none',
    },
};
